<template>
  <fragment>
    <div :class="$style['display']" class="default-display">
      {{ value }}
    </div>
    <span :class="$style['answer']">{{ answer }}</span>
  </fragment>
</template>

<script>
export default {
  created() {
    this.$store.dispatch(`templates/entity/updateFixedItem`);
  },
  computed: {
    value() {
      return this.$store.getters[`templates/entity/fixedItem`];
    },
    entity() {
      return this.$store.getters['templates/entity/entity'];
    },
    answerItems() {
     return this.$store.getters['templates/entity/answerItems'];
    },
    answer() {
      return this.answerItems[1];
    }
  }
};
</script>

<style module lang="scss">
.display {
  font-size: 15px;
  font-weight: 600;
  max-width: 600px;
}
.answer {
  margin-top: 4px;
}
</style>

<style scoped lang="scss">
.default-display {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 420px;
}
</style>
